import axios from "axios";

const updateRotationPhoto = async (endPoint, body) => {
  const token = localStorage.getItem("token");
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_URL_BACKEND}api/v1/${endPoint}`,
      body,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    const data = await res.data;
    return { data, res };
  } catch (error) {
    console.error(error);
  }
};

export default updateRotationPhoto;
